import { WSPillProps } from "@wingspanhq/fe-component-library";
import {
  InsuranceMonitor,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

import {
  RequirementContextType,
  RequirementStatusViewProps,
  RequirementTableItemData
} from "../../../../types";
import { selectorIsInsuranceMonitorInProgress } from "../../selectors/selectorIsInsuranceMonitorInProgress";

/**
 * v1 monitor statuses map onto v3 `InsuranceMonitorStatus`:
 * Pending/Monitoring → Active (watching, no compliant coverage yet);
 * Complete → Compliant; ForceMatched → NonCompliant.
 */
export const getInsuranceCoverageRequirementStatus = (
  requirement: RequirementTableItemData,
  insuranceMonitor: InsuranceMonitor | undefined,
  contextType: RequirementContextType
): RequirementStatusViewProps => {
  let pill: WSPillProps;
  let secondaryText: string | undefined;

  if (requirement.status === RequirementStatus.COMPLETED) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };
  } else if (selectorIsInsuranceMonitorInProgress(insuranceMonitor)) {
    if (contextType === RequirementContextType.Payer) {
      pill = {
        theme: "warning",
        text: "Action required",
        icon: true
      };
      secondaryText = "Awaiting your completion";
    } else {
      pill = {
        theme: "warning",
        text: "Awaiting contractor",
        icon: true
      };
      secondaryText = "Awaiting contractor completion";
    }
  } else {
    pill = {
      theme: "neutral",
      text: "Processing",
      icon: "time"
    };
  }

  return {
    pill,
    secondaryText
  };
};
